import { ApiRecordsReturn } from '@library-shared/models/api-records-return';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiRecordReturn } from '@library-shared/models/api-record-return';
import { spUser_List } from '@models/StoredProcs/spUser_List';
import { spUser_List_Online } from '@models/StoredProcs/spUser_List_Online';
import { spRole_List } from '@models/StoredProcs/spRole_List';
import { spRole_List_UserEdit } from '@models/StoredProcs/spRole_List_UserEdit';
import { vUserX } from '@models/Views-Extended/vUserX.extended';
import { spUser_Validate } from '@models/StoredProcs/spUser_Validate';
import { BaseService } from '@library-shared/base/base.service';
import { ApiReturn } from '@library-shared/models/api-return';
import { environment } from '@env/environment';

@Injectable({
    providedIn: 'root',
})
export class UserService extends BaseService {
    private apiURL = environment.apiURL + '/api/user'; // URL to web api

    UserView_ByUserID(gUserID: string): Observable<ApiRecordReturn<vUserX>> {
        const url = `${this.apiURL}/UserView_ByUserID`;
        const request = { gUserID };
        return this.http
            .post<ApiRecordReturn<vUserX>>(url, request, this.requestOptions)
            .pipe(catchError((e) => this.handleError(e)));
    }

    User_Update(user: vUserX, roles: spRole_List_UserEdit[]): Observable<ApiRecordReturn<vUserX>> {
        const url = `${this.apiURL}/User_Update`;
        const request = { user, roles };
        return this.http
            .post<ApiRecordReturn<vUserX>>(url, request, this.requestOptions)
            .pipe(catchError((e) => this.handleError(e)));
    }

    registerUser(userObject: any): Observable<ApiRecordReturn<any>> {
        const url = `${this.apiURL}/RegisterAppUser`;
        return this.http
            .post<ApiRecordReturn<any>>(url, userObject, this.requestOptions)
            .pipe(catchError((e) => this.handleError(e)));
    }

    forgotPassword(email: string): Observable<ApiReturn> {
        const url = `${this.apiURL}/ForgotPassword`;
        const params = {
            email,
        };
        return this.http.post<ApiReturn>(url, params, this.requestOptions).pipe(catchError((e) => this.handleError(e)));
    }

    passwordReset(resetToken: string, password: string): Observable<ApiReturn> {
        const url = `${this.apiURL}/PasswordReset`;
        const params = {
            resetToken,
            password,
        };
        return this.http.post<ApiReturn>(url, params, this.requestOptions).pipe(catchError((e) => this.handleError(e)));
    }

    User_List_Online(): Observable<ApiRecordsReturn<spUser_List_Online>> {
        const url = `${this.apiURL}/User_List_Online`;
        return this.http.get<ApiRecordsReturn<spUser_List_Online>>(url, this.requestOptions).pipe(
            catchError((e) => {
                return this.handleError(e);
            })
        );
    }

    User_List(): Observable<ApiRecordsReturn<spUser_List>> {
        const url = `${this.apiURL}/User_List`;
        return this.http.get<ApiRecordsReturn<spUser_List>>(url, this.requestOptions).pipe(
            catchError((e) => {
                return this.handleError(e);
            })
        );
    }

    User_Validate(user: vUserX): Observable<ApiRecordsReturn<spUser_Validate>> {
        const url = `${this.apiURL}/User_Validate`;
        const request = { user };
        return this.http
            .post<ApiRecordsReturn<spUser_Validate>>(url, request, this.requestOptions)
            .pipe(catchError((e) => this.handleError(e)));
    }

    Role_List(): Observable<ApiRecordsReturn<spRole_List>> {
        const url = `${this.apiURL}/Role_List`;
        return this.http.get<ApiRecordsReturn<spRole_List>>(url, this.requestOptions).pipe(
            catchError((e) => {
                return this.handleError(e);
            })
        );
    }

    Role_List_UserEdit(gUserID: string): Observable<ApiRecordsReturn<spRole_List_UserEdit>> {
        const url = `${this.apiURL}/Role_List_UserEdit`;
        return this.http.post<ApiRecordsReturn<spRole_List_UserEdit>>(url, { gUserID }, this.requestOptions).pipe(
            catchError((e) => {
                return this.handleError(e);
            })
        );
    }

    User_Update_Agency(req: { agency_id: string }): Observable<ApiReturn> {
        const url = `${this.apiURL}/User_Update_Agency`;
        return this.http.post<ApiReturn>(url, req, this.requestOptions).pipe(catchError((e) => this.handleError(e)));
    }
}
